import {
    DISPATCH_EVENT3,
    DISPATCH_EVENT3_SUCCESS,
} from "../constants";

export const dispatchEvent3 = ({pageType,pageId,nodeId,event,context}) => {
    return {
        type: DISPATCH_EVENT3,
        pageType,
        pageId,
        nodeId,
        event,
        context
    };
};



export const dispatchEvent3Success = ({data,warnings,errors}) => {
    return {
        type: DISPATCH_EVENT3_SUCCESS,
        data,
        errors,
        warnings
    };
};